export default __webpack_public_path__ + "static/media/search-orgs.5aaa8835.svg";